import React from 'react';

const ReviewVideo =  ({ videoId }) =>{
    return (
      <div className="video-container">
        {/* <iframe  width="100%" class="ytplayer" id="ytplayer"
  height="600"src="https://www.youtube.com/embed/R-W0dp4qbMs?si=X-k5nN4kVX7I6I3E?controls=0&modestbranding=1&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=R-W0dp4qbMs"
  frameborder="0" allowfullscreen></iframe> */}
  <iframe width="100%" height="600" src="https://www.youtube.com/embed/NgR4pOvdIWY" title="Hear It from Our Guests! Royal Chitran Google Reviews 💬 | Authentic Rajasthani Experience in Chennai" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" frameborder="0" allowfullscreen></iframe>
      </div>
    );
  };
export default ReviewVideo;